export default [{ //新结算单位管理
    path: '/settlementUnit',
    component: () =>
        import('@/components/page/settlementUnit/settlementUnitList'),
    meta: { title: 'settlementUnit.NewSettlementUnitApply' },
},
{ //新结算单位详情
    path: '/SupplierDataMaintenance',
    component: () =>
        import('@/components/page/settlementUnit/SupplierDataEdit'),
    meta: { title: 'settlementUnit.settlementUnitDetail' },
},
{ //新结算单位详情
    path: '/SupplierDataMaintenance/view',
    component: () =>
        import('@/components/page/settlementUnit/SupplierDataView'),
    meta: { title: 'settlementUnit.settlementUnitDetail' },
},
{ //法务文件管理
    path: '/LegalFile',
    component: () =>
        import('@/components/page/settlementUnit/LegalFileList'),
    meta: { title: 'settlementUnit.LegalFileManage' },
},
{ //法务文件管理
    path: '/LegalFileDetail',
    component: () =>
        import('@/components/page/settlementUnit/LegalFileDetail'),
    meta: { title: 'settlementUnit.LegalFileDetail' },
},
{ //Engagement 管理
    path: '/EngagementList',
    component: () =>
        import('@/components/page/settlementUnit/EngagementList'),
    meta: { title: 'settlementUnit.EngagementManage' },
},
{ //engagement 详情
    path: '/EngagementDetail',
    component: () =>
        import('@/components/page/settlementUnit/EngagementDetail'),
    meta: { title: 'settlementUnit.EngagementDetail' },
},

]